var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58591 9.06463L8.87246 5.90185M5.90734 9.5851L6.92911 11.7377C7.48558 12.91 7.76379 13.4961 8.1334 13.667C8.45432 13.8154 8.82637 13.8043 9.13786 13.637C9.49658 13.4443 9.73923 12.8426 10.2246 11.6391L13.3409 3.91177C13.8156 2.73484 14.0529 2.1464 13.9316 1.76157C13.8261 1.42721 13.5709 1.16114 13.2412 1.04193C12.8618 0.904682 12.264 1.11734 11.0683 1.54263L3.19909 4.3418C1.97559 4.77699 1.36379 4.99464 1.15639 5.34513C0.976259 5.64954 0.949783 6.02093 1.0849 6.3478C1.24045 6.72425 1.81519 7.02642 2.96457 7.63086L5.11902 8.76378C5.31605 8.86739 5.41462 8.91919 5.4995 8.98749C5.57483 9.04803 5.64202 9.11806 5.69946 9.19581C5.76418 9.28341 5.81195 9.38399 5.90734 9.5851Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.59c59abe9e5b56705d71b030c2eda297.svg";
export { ForwardRef as ReactComponent };